export const styles = theme => ({
    settingsMenuIcon: {
        color: "#ffffff",
        
    },
    settingsMenuItemIcon: {
        marginRight: 10
    }
});
